import React from 'react';
import { useSelector } from 'react-redux';
import { promoCodeSelector } from '../../../../store/reducers/promoCodeReducer';

function ProgressionBar({ item, progression }) {
    const circleInActive = "circle inactive";
    const promoCode = useSelector(promoCodeSelector);

    return (
        <div className="progression-bar_container">
            {promoCode.isHuri === true ?                 
                <> 
                    <div className="progression-bar">
                        <div>
                            <div className="circle"></div>
                        </div>
                        <div>
                            <div className={(progression === "/form/yourInfo") || (item >= 2) ? "circle" : circleInActive }></div>
                        </div>
                        <div>
                            <div className={((progression === "/form/primary") || (progression === "/form/secondary")) || (item >= 3) ? "circle" : circleInActive}></div>
                        </div>
                        <div>
                            <div className={(progression === "/form/nomination") || (item >= 4) ? "circle" : circleInActive}></div>
                        </div>
                        <div>
                            <div className={(progression === "/form/summary") || (item >= 5) ? "circle" : circleInActive}></div>
                        </div>
                    </div>
                    <div className={ promoCode.isHuri === true ? "progression-line longer-small" : "progression-line"}></div>
                </>
                :<>
                    <div className="progression-bar">
                        <div>
                            <div className="circle"></div>
                        </div>
                        <div>
                            <div className={(progression === "/form/yourInfo") || (item >= 2) ? "circle" : circleInActive }></div>
                        </div>
                        <div>
                            <div className={((progression === "/form/primary") || (progression === "/form/secondary")) || (item >= 3) ? "circle" : circleInActive}></div>
                        </div>
                        <div>
                            <div className={(progression === "/form/summary") || (item >= 5) ? "circle" : circleInActive}></div>
                        </div>
                    </div>
                    <div className={ promoCode.isHuri === true ? "progression-line longer-small" : "progression-line"}></div>
                </>
            }
        </div>
    );
}

export default ProgressionBar;
